
















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { loginURL } from '@/dex-shared/settings/endpoints';
import Navbar from './components/Navbar.vue';
import Sidebar from './components/Sidebar.vue';

export default Vue.extend({
  components: {
    Navbar,
    Sidebar,
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
    }),
    admin: function() {
      const user = this.$store.state.auth.user;
      return user && user.id && user.role === 'admin';
    },
    user: function() {
      const user = this.$store.state.auth.user;
      return user && user.id;
    },
  },
});
